module.exports = __webpack_public_path__ + "static/liva-basari-f2570bb5f303529c425d09a1b643725d.webp";